import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import * as React from 'react';
import { EDeviceType } from '../../types/device';
import * as responsive from '../../constants/responsive';
import { Context } from './Context';
export var Provider = /*#__PURE__*/function (_React$Component) {
  _inherits(Provider, _React$Component);

  var _super = _createSuper(Provider);

  function Provider(props) {
    var _this;

    _classCallCheck(this, Provider);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "determineDeviceType", function () {
      var deviceType = EDeviceType.Desktop;

      if (window.innerWidth < responsive.MIN_DESKTOP_WIDTH) {
        deviceType = EDeviceType.Tablet;
      }

      if (window.innerWidth < responsive.MIN_TABLET_WIDTH) {
        deviceType = EDeviceType.Phone;
      }

      _this.setState({
        deviceType: deviceType
      });
    });

    _this.state = {
      deviceType: props.deviceType
    };
    return _this;
  }

  _createClass(Provider, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.determineDeviceType();
      window.addEventListener('resize', this.determineDeviceType);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      window.removeEventListener('resize', this.determineDeviceType);
    }
  }, {
    key: "render",
    value: function render() {
      var children = this.props.children;
      var deviceType = this.state.deviceType;
      return /*#__PURE__*/React.createElement(Context.Provider, {
        value: deviceType
      }, children);
    }
  }]);

  return Provider;
}(React.Component);